module.exports = __webpack_public_path__ + "static/media/profile 2.486b1397.svg";